import React, { ReactNode } from 'react';
import Header from './header';
import Sidebar from './side-bar';
import RightSidePanel from './right-side-panel';
import useDeviceInfo from '../../../services/hooks/useDevice';
type Iprops = {
  children: ReactNode;
};

const PageLayout = ({ children }: Iprops) => {
  const { device } = useDeviceInfo();
  if (device.type === "mobile") {
    return <div className='mobile-page-layout' style={{color:"#3f3f3f"}}>
      {children}
    </div>
  }
  return (
    <>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '15% 82%',
          gridColumnGap: '1.5rem',
        }}
      >
        <Sidebar />
        <div>
          <Header />
          <div style={{
            height: "calc(100vh - 8rem)",
            overflowY: 'auto'
          }}>{children}</div>
        </div>
      </div>
      <RightSidePanel />
    </>
  );
};
export default PageLayout;
